import React from 'react'
import {Row, Col, Spin, Table} from 'antd'
import {useState, useEffect} from 'react'

export default function ViewPolicyClaim(props) {
  useEffect(() => {}, [props.parentToChild])
  const columns = [
    {
      title: 'Risk Cover(s)',
      key: '1',
      render: x => x.policy_cover,
    },
    {
      title: 'Risk Item(s)',
      key: '2',
      render: x => x.riskitemname,
    },
    {
      title: 'Sum Insured',
      render: x => x.suminsured,
      key: '3',
    },
    {
      title: 'Premium',
      render: x => x.prorata,
      key: '4',
    },
  ]
  return (
    <>
      {props.parentToChild && !props.parentToChild.policyNo.includes('OTM') && (
        <div className="dash-bg-white">
          <Row gutter={[16, 16]} style={{display: 'inline'}}>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Product : </b>
                {props.parentToChild && props.parentToChild.productName}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Policy No. : </b>
                {props.parentToChild && props.parentToChild.policyNo}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Customer Name : </b>
                {props.parentToChild && props.parentToChild.customerName}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Start Date : </b>
                {props.parentToChild && props.parentToChild.policyStartDate}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>End Date : </b>
                {props.parentToChild && props.parentToChild.policyEndDate}
              </label>
            </Col>
          </Row>
          <div className="table-grid-bx">
            <Table
              columns={columns}
              dataSource={props.parentToChild.riskItemDetails}
              scroll={{x: 768}}
              pagination={false}
            />
          </div>
        </div>
      )}
      {props.parentToChild && props.parentToChild.policyNo.includes('OTM') && (
        <div className="dash-bg-white">
          <Row gutter={[16, 24]}>
            <Col xs={12} sm={24} md={12} lg={12}>
              <h3
                style={{
                  color: '#F15A2B',
                  fontWeight: '700',
                  fontSize: '20px',
                  margin: '0',
                }}>
                Policy Details
              </h3>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{display: 'inline'}}>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Product : </b>
                {props.parentToChild && props.parentToChild.productName}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Customer Name : </b>
                {props.parentToChild && props.parentToChild.customerName}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Policy No. : </b>
                {props.parentToChild && props.parentToChild.policyNo}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Start Date : </b>
                {props.parentToChild && props.parentToChild.policyStartDate}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>End Date : </b>
                {props.parentToChild && props.parentToChild.policyEndDate}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>VRN : </b>
                {props.parentToChild && props.parentToChild.vrn}
              </label>
            </Col>
          </Row>
        </div>
      )}
    </>
  )
}
